
import { Outlet } from 'react-router-dom';
import HeaderSection from '../Screens/CommingSoon/Header';
import FooterSection from '../ComingSoonSections/Footer';

export default function PublicLayout() {
    return (
        <div className="flex flex-col min-h-screen">
            <HeaderSection />

            <main className="flex-1">
                <Outlet />
            </main>

            <FooterSection />
        </div>
    );
}